import React, { ReactNode, useCallback, useState, useRef } from "react"
import "./ContextMenu.scss"
import { CustomOverlayProps } from "../../utility/common/customOverlayTypes"
import { Overlay } from "react-bootstrap"
import cn from "classnames"
import { OverlayInjectedProps } from "react-bootstrap/esm/Overlay"

export interface ContextMenuProps extends CustomOverlayProps {
    children: ReactNode
    items: ReactNode
    closeWhenClickInside?: boolean
    containerClassName?: string
    onHide?: () => void
    disabled?: boolean
    keepOnlyOneOpened?: boolean
    show?: boolean
}

function ContextMenu(props: ContextMenuProps) {
    const {
        children,
        items,
        className,
        closeWhenClickInside = true,
        containerClassName,
        onHide,
        disabled = false,
        keepOnlyOneOpened,
        show: controlledShow
    } = props

    const triggerRef = useRef<HTMLDivElement>(null)
    const [internalShow, setInternalShow] = useState(false)

    const isControlled = controlledShow !== undefined
    const show = isControlled ? controlledShow : internalShow

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            e.stopPropagation()

            if (!disabled && !isControlled) {
                setInternalShow(!internalShow)
            }
        },
        [internalShow, disabled, isControlled]
    )

    const handleCloseOtherMenus = () => {
        const contextMenus: NodeListOf<HTMLDivElement> = document.querySelectorAll(".context-menu")
        contextMenus.forEach(menu => {
            if (menu !== triggerRef.current) {
                menu.style.display = "none"
            }
        })
    }

    return (
        <>
            <Overlay
                {...props}
                rootClose={!isControlled}
                onHide={
                    isControlled
                        ? undefined
                        : () => {
                              setInternalShow(false)
                              onHide && onHide()
                          }
                }
                show={show}
                target={triggerRef ? (triggerRef.current ? triggerRef.current : null) : null}
            >
                {({ ref, placement, style }: OverlayInjectedProps) => (
                    <div
                        ref={ref}
                        style={style}
                        className={cn("context-menu", className)}
                        data-placement={placement}
                        onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                            e.stopPropagation()
                            if (closeWhenClickInside && !isControlled) {
                                setInternalShow(false)
                            }
                        }}
                    >
                        {items}
                    </div>
                )}
            </Overlay>
            <div
                className={cn("context-menu__container", containerClassName)}
                ref={triggerRef}
                onClick={e => {
                    handleClick(e)
                    keepOnlyOneOpened && handleCloseOtherMenus()
                }}
            >
                {children}
            </div>
        </>
    )
}

export default ContextMenu
